import { Component, inject } from '@angular/core';
import { MetaDataService } from '../metadata.service';

@Component({
    selector: 'tea-shop-fe-terms-of-service',
    templateUrl: './terms-of-service.component.html',
    styleUrl: './terms-of-service.component.css'
})
export class TermsOfServiceComponent {
  private metaDataService = inject(MetaDataService);


  constructor() { 
    this.metaDataService.updateMetadata({
      title: 'Terms of Service',
      image: '/assets/contact/sencha-logo.png',
    });
  }
}
